import { create } from "zustand";
import { persist } from "zustand/middleware";

const CityListStore = create(
  persist(
    (set) => ({
      cityList: [],
      setCityList: (selectedCityList) => {
        // console.log('Received data in setCityList:', selectedCityList);

        if (
          selectedCityList &&
          Array.isArray(selectedCityList)
        ) {
          set({ cityList: selectedCityList });
          console.log('Successfully set city list to:', selectedCityList);
        } else {
          console.error(
            "Invalid city list format. Expected array, received:",
            selectedCityList
          );
        }
      },
      removeCityList: () =>
        set({
          cityList: [],
        }),
    }),
    {
      name: "cityList-storage",
      getStorage: () => localStorage,
    }
  )
);

export default CityListStore;